import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
    import('./pages/home/home.component').then(m => m.HomeComponent),
    title: 'Home | United Team Building'
  },
  {
    path: 'services',
    loadComponent: () =>
      import('./pages/services/services.component').then(m => m.ServicesComponent),
    title: 'Services | United Team Building'
  },
  {
    path: 'q-and-a',
    loadComponent: () =>
      import('./pages/q-and-a/q-and-a.component').then(m => m.QAndAComponent),
    title: 'Q & A | United Team Building'
  },
  {
    path: 'testimonials',
    loadComponent: () =>
      import('./pages/testimonials/testimonials.component').then(m => m.TestimonialsComponent),
    title: 'Testimonials | United Team Building'
  },
  {
    path: 'testimonial/:slug',
    loadComponent: () =>
      import('./pages/testimonial-detail/testimonial-detail.component').then(m => m.TestimonialDetailComponent),
    title: 'Testimonial | United Team Building'
  },
  {
    path: 'contact-us',
    loadComponent: () =>
      import('./pages/contact-us/contact-us.component').then(m => m.ContactUsComponent),
    title: 'Contact Us | United Team Building'
  },
  {
    path: 'about-us',
    loadComponent: () =>
      import('./pages/about-us/about-us.component').then(m => m.AboutUsComponent),
    title: 'About Us | United Team Building'
  },
  {
    path: 'legal',
    loadComponent: () =>
      import('./pages/legal/legal.component').then(m => m.LegalComponent),
    title: 'Legal | United Team Building'
  },

  // Friendly alias redirects
  {
    path: 'contact',
    redirectTo: 'contact-us',
    pathMatch: 'full'
  },
  {
    path: 'about',
    redirectTo: 'about-us',
    pathMatch: 'full'
  },
  {
    path: 'home',
    redirectTo: '',
    pathMatch: 'full'
  },

  // 404
  {
    path: '**',
    loadComponent: () =>
      import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent),
    title: 'Page Not Found | United Team Building'
  }
];
